import { ajax } from 'rxjs/observable/dom/ajax';
import { Observable } from 'rxjs';
import * as actions from '../actions';
import { getSSOEndpointUrl } from '../utils/apiHelper';
import { ActionTypes, LAST_PAGE_KEY } from '../constants';
import { getSubdomain, getQueryParamValue, SessionStorageUtil } from '../utils';

function doSSOAuthentication({ response } = {}) {
  const ssoEndpointUri = response;
  if (response) {
    // location.replace unlike location.href is replacing the current URL with the destination URL
    // so if the user will click the back button he won't be directed to the SSO app
    window.location.replace(ssoEndpointUri);
  } else {
    return actions.setError('ERROR: failed to fetch the SSO endpoint URL');
  }
}

export function saveLastPage() {
  const lastPageQP = getQueryParamValue(window.location, 'lastPage');
  if (lastPageQP && lastPageQP !== 'null') {
    SessionStorageUtil.setInSessionStorage(
      LAST_PAGE_KEY,
      decodeURIComponent(lastPageQP)
    );
  } else {
    SessionStorageUtil.removeFromSessionStorage(LAST_PAGE_KEY);
  }
}

export function preSSOEpic(action$) {
  return action$
    .ofType(ActionTypes.HANDLE_PRE_SSO_STAGE)
    .do(() => saveLastPage())
    .mergeMap(({ payload }) => [
      actions.setSSOStage(payload.ssoStage),
      actions.fetchSSODetails(getSubdomain(window.location)),
    ]);
}

export function fetchSSOEndpointEpic(action$) {
  return action$
    .ofType(ActionTypes.FETCH_SSO_ENDPOINT)
    .mergeMap(({ payload }) =>
      ajax({
        url: getSSOEndpointUrl({ subUrlDomain: payload.companyId }),
        responseType: 'text',
      })
        .map(response => doSSOAuthentication(response))
        .catch(error => Observable.of(actions.setError(error.message)))
    );
}



// WEBPACK FOOTER //
// ./src/epics/preSSOEpics.js